import React from "react";
import AnimatedContainer from "./AnimatedContainer";
import Card from "./Card";

function Reciclaje (){
    const imageUrl='https://raw.githubusercontent.com/LTuhay/rosa-recicla/master/public/assets/recycle.jpg';
    const text='Se entiende por “reciclar” a la actividad que convierte los materiales desechables en materia prima para la elaboración de otros productos. Es dar otra oportunidad a estos materiales que desechamos a diario.'
    const additionalText= '';

    return (
        <div>
            <AnimatedContainer animationDuration="2s">
                <Card image={imageUrl} title='¿Qué es reciclar?' text={text} additionalText={additionalText} imagePosition='right' />
            </AnimatedContainer>
        </div>
    )
}

export default Reciclaje;